const KEY = "ct_cookie_consent_v1";
export const CONSENT_EVENT = "ct-consent-change";

export const defaultConsent = { necessary: true, statistik: false };

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...defaultConsent, ...JSON.parse(raw), decided: true } : { ...defaultConsent, decided: false };
  } catch {
    return { ...defaultConsent, decided: false };
  }
}

export function saveConsent(consent) {
  const value = { ...defaultConsent, ...consent, necessary: true, date: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(value));
  applyConsent(value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { ...value, decided: true } }));
}

export function resetConsent() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { ...defaultConsent, decided: false } }));
}

export function applyConsent(consent) {
  const ph = window.posthog;
  if (!ph) return;
  try {
    if (consent.statistik) ph.opt_in_capturing?.();
    else ph.opt_out_capturing?.();
  } catch (_) {}
}
